import React from "react";
import {
	Box,
	Typography,
	Modal,
	Paper,
	List,
	ListItem,
	ListItemText,
	Divider,
	Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import DeleteIcon from "@mui/icons-material/Delete";

const UploadStatusPopover = ({
	open,
	onClose,
	stats,
	deletedFiles = [],
	failedFiles = [],
}) => {
	const { total = 0, success = [], deleted = [], failed = [], errors = []} = stats || {};
	const has429 = (errors || []).some(e => String(e).includes("429"));


	return (
		<Modal open={open} onClose={onClose}>
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				height="100vh"
			>
				<Paper
					sx={{
						p: 4,
						width: 450,
						maxHeight: "80vh",
						overflowY: "auto",
						borderRadius: 3,
					}}
				>
					<Typography
						variant="h6"
						sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
					>
						<CheckCircleIcon color="success" /> Upload Completed
					</Typography>

					<Box mb={2}>
						<Typography variant="body2">
							Total Uploaded: <strong>{total}</strong>
						</Typography>
						<Typography variant="body2" color="success.main">
							Successful: <strong>{success}</strong>
						</Typography>
						<Typography variant="body2" color="warning.main">
							Deleted (Quality Check): <strong>{deleted}</strong>
						</Typography>
						<Typography variant="body2" color="error.main">
							Failed: <strong>{failed}</strong>
						</Typography>
					</Box>

					{has429 && (
						<Box
							sx={{
								mb: 2,
								p: 2,
								border: '1px solid',
								borderColor: 'error.main',
								bgcolor: 'rgba(244,67,54,0.08)',
								borderRadius: 2,
							}}
						>
							<Typography variant="subtitle2" sx={{ color: 'error.main', fontWeight: 800 }}>
							OpenAI account balance is low — please top up.
							<br />
							OpenAI 账号余额不足，请及时充值。
							</Typography>
						</Box>
					)}


					{deletedFiles.length > 0 && (
						<>
							<Divider sx={{ my: 2 }} />
							<Typography
								variant="subtitle2"
								sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
								color="warning.main"
							>
								<DeleteIcon fontSize="small" /> Deleted Files
							</Typography>
							<List dense>
								{deletedFiles.map((file, idx) => (
									<ListItem key={idx} disablePadding>
										<ListItemText primary={file} />
									</ListItem>
								))}
							</List>
						</>
					)}

					{failedFiles.length > 0 && (
						<>
							<Divider sx={{ my: 2 }} />
							<Typography
								variant="subtitle2"
								sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
								color="error.main"
							>
								<ErrorIcon fontSize="small" /> Failed Uploads
							</Typography>
							<List dense>
								{failedFiles.map((file, idx) => (
									<ListItem key={idx} disablePadding>
										<ListItemText primary={file.filename} />
									</ListItem>
								))}
							</List>
						</>
					)}

					{errors.length > 0 && (
						<>
							<Divider sx={{ my: 2 }} />
							<Typography
								variant="subtitle2"
								sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
								color="error.main"
							>
								<ErrorIcon fontSize="small" /> Error Messages
							</Typography>
							<List dense>
								{errors.map((msg, idx) => (
									<ListItem key={idx} disablePadding>
										<ListItemText
											primary={msg}
											slotProps={{
												primary: { sx: { whiteSpace: 'pre-line', mb: 1 } }
											}}
										/>
									</ListItem>
								))}
							</List>
						</>
					)}

					<Divider sx={{ my: 2 }} />
					<Button variant="contained" onClick={onClose} fullWidth>
						Close
					</Button>
				</Paper>
			</Box>
		</Modal>
	);
};

export default UploadStatusPopover;
